@let loaded = loaded$ | async;
<div class="collapsible-button">
  <div
    matRipple
    class="page-action-button"
    [class.disabled]="!loaded"
    (click)="!loaded ? $event.stopImmediatePropagation() : null"
  >
    <gb-button-loader [loaded$]="loaded$">
      <div class="button-inner">
        <gb-icon [icon]="icon" [library]="iconLibrary"></gb-icon>
        <span [translateParams]="labelTranslateParams" [translate]="label"></span>
      </div>
    </gb-button-loader>
  </div>
</div>
